import { Type } from '@angular/core';

import { ContentComponentType } from '@ppg/core/enums';
import { CuratedColorPaletteComponent } from '@ppg/shared/color/curated-color-palette';
import {
  AssetYoutubeVideoComponent,
  CenteredContentBlockComponent,
  Container603010ContentComponent,
  ContainerHighImagesStripComponent,
  ContainerImageGalleryComponent,
  ContentBannerComponent,
  EdgeToEdgeComponent,
  FaqComponent,
  IFrameWidgetComponent,
  ImageWithColorsUsedComponent,
  InlineImageComponent,
  ResourceListComponent,
  SocialSharingComponent,
  StepsComponent,
} from '@ppg/shared/components';
import { ContainerCardComponent } from '@ppg/shared/container-card';
import { ContainerContentBannerComponent } from '@ppg/shared/container-content-banner';
import { RichTextComponent } from '@ppg/shared/rich-text';

export const CONTENT_COMPONENTS_MAP = {
  [ContentComponentType.ARTICLE_LIST_ITEM]: RichTextComponent,
  [ContentComponentType.ASSET_YOUTUBE_VIDEO]: AssetYoutubeVideoComponent,
  [ContentComponentType.CENTERED_CONTENT_BLOCK]: CenteredContentBlockComponent,
  [ContentComponentType.CODE_IFRAME_WIDGET]: IFrameWidgetComponent,
  [ContentComponentType.CONTAINER_CARD]: ContainerCardComponent,
  [ContentComponentType.CONTAINER_CONTENT_BANNER]: ContainerContentBannerComponent,
  [ContentComponentType.CONTENT_BANNER]: ContentBannerComponent,
  [ContentComponentType.FAQ]: FaqComponent,
  [ContentComponentType.INLINE_IMAGE]: InlineImageComponent,
  [ContentComponentType.ITEM_PERSON]: RichTextComponent,
  [ContentComponentType.RICH_TEXT]: RichTextComponent,
  [ContentComponentType.SOCIAL_SHARING]: SocialSharingComponent,
  [ContentComponentType.CONTAINER_IMAGE_GALLERY]: ContainerImageGalleryComponent,
  [ContentComponentType.CONTAINER_HIGH_IMAGE_STRIP]: ContainerHighImagesStripComponent,
  [ContentComponentType.COMPONENT_IMAGE_WITH_COLORS_USED]: ImageWithColorsUsedComponent,
  [ContentComponentType.EDGE_TO_EDGE]: EdgeToEdgeComponent,
  [ContentComponentType.RESOURCE_LIST]: ResourceListComponent,
  [ContentComponentType.CONTAINER_603010_COLORS]: Container603010ContentComponent,
  [ContentComponentType.COMPONENT_STEPS]: StepsComponent,
  [ContentComponentType.CURATED_COLOR_PALETTE]: CuratedColorPaletteComponent,
} satisfies { [key in ContentComponentType]?: Type<unknown> };
